import { createContext } from 'react';

/**
 * Account-level feature flags (skin ChannelInfo settings, the account's own SRA AccessType, ...)
 * that deep Clients components need without prop-drilling through every intermediate view.
 * Provided by ProGroupsShell once the relevant account data resolves; defaults to everything
 * off, so a component rendered outside the shell (or before that data has loaded) keeps the
 * default behavior.
 */
export interface SkinFeatures {
  /** ChannelInfo 'enablereportpdf' — PDF action lives in the ReportView header instead of the Clients report columns. */
  enableReportPdf: boolean;
  /**
   * The active account's own SRA record is AccessType 10 (Pro) rather than 11+ (Groups) — see
   * AccountSettingsView's isRestrictedSettingsMode for the same check. NOT the signed-in
   * session's accessType (which is 10 for anyone entering via the Pro route, Groups accounts
   * included) — that distinction is exactly what caused an earlier bug (the Assessment Options
   * tab briefly hiding for Groups accounts too), so don't substitute session accessType here.
   */
  isProAccount: boolean;
}

export const DEFAULT_SKIN_FEATURES: SkinFeatures = { enableReportPdf: false, isProAccount: false };

export const SkinFeaturesContext = createContext<SkinFeatures>(DEFAULT_SKIN_FEATURES);
